import { useCallback, useRef } from 'react';

const useScrollToElement = (scrollOptions) => {
  const scrollRef = useRef(null);

  const scrollToElement = useCallback(() => {
    if (!scrollRef.current) {
      return;
    }

    scrollRef.current.scrollIntoView(scrollOptions);
  }, []);

  return {
    scrollRef,
    scrollToElement,
  };
};

export default useScrollToElement;
